import React from "react";
import { Leaf, Facebook } from "lucide-react";
import { footerColumns, FACEBOOK_URL } from "../data/mock";
import { Logo } from "./Header";
import AwardBadges from "./AwardBadges";

const Footer = () => {
  return (
    <footer className="bs-footer" id="footer">
      <div className="bs-container">
        <div className="bs-footer__top">
          <div className="bs-footer__brand">
            <a href="#home" className="bs-brand-link"><Logo light /></a>
            <p className="bs-footer__about">
              Online British Sign Language course, dictionary and learning resources.
            </p>
            <div className="bs-footer__social">
              <a
                href={FACEBOOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow british-sign.co.uk on Facebook"
                title="Follow us on Facebook"
                data-testid="footer-facebook"
              >
                <Facebook size={18} aria-hidden="true" />
              </a>
            </div>
            <AwardBadges variant="footer" />
          </div>

          <div className="bs-footer__cols">
            {footerColumns.map((col) => (
              <div className="bs-footer__col" key={col.heading}>
                <div className="bs-footer__heading">{col.heading}</div>
                <ul>
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        {...(l.external
                          ? { target: "_blank", rel: "noopener noreferrer" }
                          : {})}
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="bs-footer__bottom">
          <div>© {new Date().getFullYear()} british-sign.co.uk · All rights reserved · Lisia Digital Limited · VAT GB 370 9353 85</div>
          <div className="bs-footer__green">
            <button
              type="button"
              onClick={() => {
                if (typeof window !== "undefined" && window.openCookieSettings) {
                  window.openCookieSettings();
                }
              }}
              data-testid="footer-cookie-settings"
              style={{
                background: "transparent",
                border: "none",
                padding: 0,
                font: "inherit",
                color: "inherit",
                cursor: "pointer",
                textDecoration: "underline",
              }}
            >
              Cookie settings
            </button>
            <span style={{ opacity: 0.5 }}>·</span>
            <Leaf size={14} />
            <a href="/carbon-footprint">Reducing our carbon footprint</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
